/**
 * @file        jnu-kvin.js - KVIN configuraiton shared between jnu daemon and client library.
 */
'use strict';

const KVINv8 = new (require('kvin-v8').KVIN)();
KVINv8.userCtors.dcpUrl$$DcpURL  = require('dcp/common/dcp-url').DcpURL;
KVINv8.userCtors.dcpEth$$Address = require('dcp/dcp-client/wallet').Address;
KVINv8.userCtors.BigNumber       = require('dcp/types').BigNumber;
exports.KVINv8 = KVINv8;

const KVINv9 = new (require('kvin').KVIN)();
KVINv9.userCtors.dcpUrl$$DcpURL  = require('dcp/common/dcp-url').DcpURL;
KVINv9.userCtors.dcpEth$$Address = require('dcp/dcp-client/wallet').Address;
KVINv9.userCtors.BigNumber       = require('dcp/types').BigNumber;
exports.KVINv9 = KVINv9;
